import * as Yup from 'yup';
import { MAX_NUMBER_OF_GUESTS, REGEX_VALIDATION_CRUISE_CREDIT } from '../../commons';

const validationSchema = (renderContent, showEmailInput) => {
  const regex = REGEX_VALIDATION_CRUISE_CREDIT;
  const field = renderContent('formCruiseCreditCertificate', 'Enter certificate number');
  const required = renderContent('formCruiseCreditCertificateRequired', 'Required Field');
  const invalid = renderContent(
    'formCruiseCreditCertificateInvalid',
    'Invalid future cruise credit',
  );

  const fccValidator = [...Array(parseInt(MAX_NUMBER_OF_GUESTS, 10)).keys()].reduce(
    (accumulator, currentValue) => {
      return {
        ...accumulator,
        [`cruiseCredit_${currentValue}`]: currentValue
          ? Yup.string(field).matches(regex, invalid)
          : Yup.string(field).required(required).matches(regex, invalid),
      };
    },
    {},
  );

  const emailValidator = {
    emailAddress: Yup.string(renderContent('formCruiseCreditFieldEmail', 'Enter an email address'))
      .email(
        renderContent(
          'formCruiseCreditEmailInvalidFormat',
          'Enter a valid email address: username@example.com',
        ),
      )
      .required(renderContent('formBookingAmendRequiredEmail', 'Email address is required')),
  };

  const validator = {
    ...(showEmailInput && { ...emailValidator }),
    ...fccValidator,
  };
  return Yup.object(validator);
};

export default validationSchema;
